<template>
    <div class="modal" id="modalDetailPo" role="dialog">
        <div class="modal-dialog modal-lg" role="document" style="max-width: 900px;">
            <div class="modal-content">
                <div class="modal-header">
                    <div>
                        <h5 class="modal-title">Detail {{modalData.type == 'PO' ? 'Purchase Order' : 'Purchase Receipt'}}</h5>
                        <div class="modal-subtitle">{{ modalData.type == 'PO' ? modalData.id :modalData.prId }}</div>
                    </div>
                    <button type="button" class="close" @click="closeModal">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <!-- Info Box -->
                    <div class="info-box">
                        <div class="info-row">
                            <div class="info-item">
                                <div class="info-item-label">Nama Supplier</div>
                                <div class="info-item-value">{{ modalData.supplier }}</div>
                            </div>
                            <div class="info-item">
                                <div class="info-item-label">Tanggal Dibuat</div>
                                <div class="info-item-value">{{ modalData.createdDate ? formatDate(modalData.createdDate) : '-' }}</div>
                            </div>
                            <div class="info-item">
                                <div class="info-item-label">Total</div>
                                <div class="info-item-value">Rp {{ modalData.total ? formatNumber(modalData.total) : 0 }}</div>
                            </div>
                            <div class="info-item">
                                <div class="info-item-label">Status</div>
                                <div class="info-item-value">
                                    <span class="status-badge">{{ modalData.status }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Details Table -->
                    <div class="modal-details-section">
                        <div class="modal-details-title">Details</div>
                        <table class="details-table">
                            <thead>
                                <tr>
                                    <th>NO ITEM</th>
                                    <th>NAMA ITEM</th>
                                    <th>BATCH NUMBER ID</th>
                                    <th class="text-center">QTY DALAM PO</th>
                                    <th class="text-center">SUDAH DITERIMA</th>
                                    <th class="text-center">SISA</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in modalData.items" :key="item.id">
                                    <td>{{ item.itemCode }}</td>
                                    <td>{{ item.itemName }}</td>
                                    <td :class="{ 'text-muted': !item.batchNumber }">{{ item.batchNumber || '-' }}</td>
                                    <td class="text-center">{{ item.qtyTotal || 0}}</td>
                                    <td class="text-center" :class="item.qtyReceived > 0 ? 'text-success' : ''">{{ item.qtyReceived }}</td>
                                    <td class="text-center" :class="item.qtyRemaining > 0 ? 'text-primary' : ''">{{ item.qtyRemaining }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-kembali" @click="closeModal">Kembali</button>
                    <button type="button" class="btn btn-buat-receipt" @click="toCreateReceiptPage(modalData)" v-if="modalData.type == 'PO'">
                        <i class="fas fa-plus"></i> Buat Receipt
                    </button>
                    <button type="button" class="btn btn-buat-receipt" @click="showModal('modalDownloadPoLabel','Free', modalData)" v-else>
                        <i class="fas fa-download"></i> Download Label
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: 'ModalPoDetail',
  props: ['modalData', 'showModal'],
  data () {
    return {
      invoiceDetailLogData : [],
    }
  },
  methods:{
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    closeModal() {
       $(`#modalDetailPo`).modal('hide')
    },
    formatNumber(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    formatDate(date) {
        let newDate = date.split(' ')[0].split('-')
        return `${newDate[2]}/${newDate[1]}/${newDate[0]}`
    },
    toCreateReceiptPage() {
      this.$router.push({
        path: '/purchase/receipt/create',
        query: {
            poId : this.modalData.id,
            supplierName : this.modalData.supplier,
        }
      })
    },
  },
  created(){
    this.admin = localStorage.getItem('admin_name')
    // this.cekLogin()
    // this.cekPermission()
  }
}
$(document).ready(function(){
  var self = this
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 /* Modal Styles */
    .modal-header {
      border-bottom: 1px solid #e0e0e0;
      padding: 20px 24px;
    }
    .modal-title {
      font-size: 18px;
      font-weight: 600;
      color: #212529;
    }
    .modal-subtitle {
      font-size: 14px;
      color: #6c757d;
      margin-top: 4px;
    }
    .modal-body {
      padding: 24px;
    }
    .modal-footer {
      border-top: 1px solid #e0e0e0;
      padding: 16px 24px;
      background-color: #f8f9fa;
    }
    .close {
      font-size: 28px;
      font-weight: 300;
      color: #6c757d;
      opacity: 0.5;
    }
    .close:hover {
      opacity: 0.8;
    }
    
    /* Info Box in Modal */
    .info-box {
      background-color: #f8f9fa;
      border: 1px solid #e0e0e0;
      border-radius: 6px;
      padding: 20px;
      margin-bottom: 24px;
    }
    .info-row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 16px;
    }
    .info-row:last-child {
      margin-bottom: 0;
    }
    .info-item {
      flex: 1;
    }
    .info-item-label {
      font-size: 12px;
      color: #6c757d;
      margin-bottom: 4px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
    .info-item-value {
      font-size: 14px;
      color: #212529;
      font-weight: 500;
    }
    .status-badge {
      display: inline-block;
      padding: 4px 12px;
      border-radius: 12px;
      font-size: 12px;
      font-weight: 500;
      background-color: #e7f3ff;
      color: #0066cc;
    }
    
    /* Table in Modal */
    .modal-details-section {
      margin-top: 24px;
    }
    .modal-details-title {
      font-size: 16px;
      font-weight: 600;
      color: #212529;
      margin-bottom: 16px;
    }
    .details-table {
      width: 100%;
      border-collapse: separate;
      border-spacing: 0;
      border: 1px solid #e0e0e0;
      border-radius: 6px;
      overflow: hidden;
    }
    .details-table thead {
      background-color: #f8f9fa;
    }
    .details-table th {
      padding: 12px;
      text-align: left;
      font-size: 11px;
      font-weight: 600;
      color: #6c757d;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      border-bottom: 1px solid #e0e0e0;
    }
    .details-table td {
      padding: 16px 12px;
      font-size: 14px;
      color: #212529;
      border-bottom: 1px solid #f0f0f0;
    }
    .details-table tbody tr:last-child td {
      border-bottom: none;
    }
    .details-table tbody tr:hover {
      background-color: #f8f9fa;
    }
    .text-center {
      text-align: center;
    }
    .text-success {
      color: #28a745 !important;
      font-weight: 500;
    }
    .text-primary {
      color: #007bff !important;
      font-weight: 500;
    }
    .text-muted {
      color: #6c757d !important;
    }
    
    /* Buttons */
    .btn-kembali {
      background-color: white;
      border: 1px solid #ddd;
      color: #333;
      padding: 8px 20px;
      font-size: 14px;
    }
    .btn-buat-receipt {
      background-color: #007bff;
      border: none;
      color: white;
      padding: 8px 20px;
      font-size: 14px;
    }
    .btn-buat-receipt:hover {
      background-color: #0056b3;
    }
    .btn-buat-receipt i {
      margin-left: 8px;
    }
    
    .details-section {
      background: white;
      border: 1px solid #e0e0e0;
      border-radius: 6px;
      padding: 0;
      margin-top: 20px;
    }
    .details-header {
      padding: 20px;
      border-bottom: 1px solid #e0e0e0;
    }
    .details-header h5 {
      color: #333;
      font-size: 16px;
      font-weight: 600;
      margin: 0;
    }
    .action-buttons {
      margin-top: 20px;
      text-align: right;
    }
    .btn-cancel {
      background-color: white;
      border: 1px solid #ddd;
      color: #333;
      padding: 8px 24px;
      margin-right: 10px;
    }
    .btn-create {
      background-color: #007bff;
      border: none;
      color: white;
      padding: 8px 24px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Purchase/CustomComponent/ModalPoDetail.vue